import { render, staticRenderFns } from "./FeedbackForm.vue?vue&type=template&id=882f9ed2"
import script from "./FeedbackForm.vue?vue&type=script&lang=js"
export * from "./FeedbackForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports